import { PeopleIcon } from '@syncfusion/react-icons';

export const LoginPage = () => {

    return (<div style={{display:'flex', justifyContent:'center', alignItems:'center', height:"100%"}}>
            <a className='sf-btn sf-control sf-align-center sf-btn-horizontal sf-icon-btn sf-icon-btn-me sf-btn-left sf-btn-color sf-btn-primary sf-btn-filled sf-btn-me' href='/auth/google'><PeopleIcon/> Iniciar con google</a>
        </div>)

};